import { useAuroraStore } from '../../store/auroraStore'
import { ToolActivity } from './ToolActivity'
import { ArtifactChip } from './ArtifactChip'
import { Markdown } from './Markdown'

/**
 * One turn.
 *
 * The parent's words sit in a bubble; the agent's do not — assistant replies are
 * often long and thoughtful, and prose in the content column reads far better
 * than a giant tinted blob.
 */
export function Message({ message, isLast }: { message: any; isLast: boolean }) {
  const attachments: any[] = message.attachments ?? []
  const artifactIds = attachments
    .filter((a) => a?.kind === 'artifact' && a.artifactId)
    .map((a) => a.artifactId)

  if (message.role === 'user') {
    return (
      <div className="msg msg-user">
        <div className="msg-user-bubble">
          {message.content}
          {artifactIds.length > 0 && (
            <div className="msg-attachments">
              {artifactIds.map((id: string) => <ArtifactChip key={id} artifactId={id} />)}
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="msg msg-agent">
      {message.toolCalls?.length > 0 && <ToolActivity calls={message.toolCalls} />}

      {message.content && <Markdown text={message.content} />}

      {message.streaming && (
        <span className="msg-cursor" aria-label="Aurora is writing" />
      )}

      {message.error && (
        <p className="msg-error">
          {message.error}
        </p>
      )}

      {artifactIds.length > 0 && (
        <div className="msg-artifacts">
          {artifactIds.map((id: string) => <ArtifactChip key={id} artifactId={id} expanded />)}
        </div>
      )}
    </div>
  )
}
